export enum VariablesFiltersActionTypes {
  SetSearchInputValue = 'variablesFilters/setSearchInputValue',
  ToggleFiltersPopup = 'variablesFilters/toggleFiltersPopup',
  ChangePopupFilters = 'variablesFilters/changePopupFilters',
  ResetAllFilters = 'variablesFilters/resetAllFilters',
  FilterVariablesByMembers = 'variablesFilters/filterByMembers',
}
